import request from '@/utils/request'

// 根据类型查询文章
export function articleList(query) {
  return request({
    url: '/web/menu/articleList',
    method: 'get',
    params: query
  })
}